meedy.controller('meedy.invoiceListController', ['$scope', '$state', '$sce', '$mdToast', '$mdDialog', '$translate',
    'meedy.objectHelper', 'applicationModel', 'meedy.userModel', 'meedy.invoiceModel', 'meedyConfig', '$location', 'meedy.blobUtils',
    function ($scope, $state, $sce, $mdToast, $mdDialog, $translate, objectHelper, applicationModel, userModel, invoiceModel,
			  meedyConfig, $location, blobUtils) {

        var listeners = {};

        function setData() {
            $scope.messages = [];
            $scope.criteria = new InvoiceDataGridMeedyCriteria();
            $scope.criteria.sortColumns = [{columnName: "id", descending: true}];
            $scope.criteria.endDate = new Date().setSeconds(0,0);

            $scope.columns = [
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.INVOICE_DATE'),
                    cellTemplate: 'meedy/application/view/app/invoice/grid-templates/data-invoice-list-date.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.NUMBER'),
                    field: "number"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.ISSUE'),
                    cellTemplate: 'meedy/application/view/app/invoice/grid-templates/data-invoice-list-issue.html'
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.BUYER_NAME'),
                    field: "buyerName"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.NET_VALUE'),
                    field: "salesAmount"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.TAX_RATE'),
                    field: "vat"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.GROSS_VALUE'),
                    field: "invoiceAmount"
                },
                {
                    displayName: $translate.instant('T.MEEDY.MODULE.INVOICE.ACTION'),
                    cellTemplate: 'meedy/application/view/app/invoice/grid-templates/data-invoice-list-action.html'
                }
            ];

            $scope.filters = [
                {type : 'date', value : undefined, fieldName : 'startDate', label : 'T.MEEDY.MODULE.INVOICE.DATE_FROM'},
                {type : 'date', value : new Date(), fieldName : 'endDate', label : 'T.MEEDY.MODULE.INVOICE.DATE_TO'}
            ];

        }

        function setPermissions() {
        }

        function setListeners() {
            listeners.onWpInvoicesLoad = function(dataPage) {
                $scope.invoices = dataPage.data;
                $scope.numberOfPages = dataPage.numberOfPages;
            };

            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {

            $scope.downloadPDF = function(invoice) {
                $scope.selectedInvoiceId = invoice.id;
                invoiceModel.getDownloadToken(invoice.id, new GeneratedFileTypeMeedyVO(Enum.MEEDY.GENERATED_FILE_TYPE.WP_INVOICE)).then(function (data) {
                    invoiceModel.download(data).then(function (url) {
						blobUtils.saveAsPdf(url, 'faktura.pdf');
                    })
                });
                
                
            };
			
            $scope.issueNumber = function(invoice) {
                $mdDialog.show({
                    templateUrl: 'meedy/application/view/app/invoice/popup/invoice-number-popup.html',
                    controller: 'meedy.popupInvoiceNumberController',
                    resolve: {
                        invoice: function () {
                            return invoice;
                        },
                        title: function() {
                            return 'T.MEEDY.MODULE.INVOICE.EDIT_INVOICE';
                        }
                    }
                }).then(function () {
                    $scope.criteriaChanged();
                }, function (error) {

                });
            };

            $scope.criteriaChanged = function() {
                invoiceModel.getWpInvoices($scope.criteria).then(listeners.onWpInvoicesLoad);
            };
        }

        function configureInterface() {
            applicationModel.selectMenuItemWithState(Constant.STATE.APP.MEEDY.INVOICE.LIST);

            var breadcrumbItems = [];
            applicationModel.setBreadcrumbItems(breadcrumbItems);
            applicationModel.setTitleBar('T.MEEDY.UI.APPLICATION.INVOICES');
        }

        function initialize() {
            //invoiceModel.getInvoices($scope.criteria);
            invoiceModel.getWpInvoices($scope.criteria).then(listeners.onWpInvoicesLoad);
            applicationModel.fillViewportMode = true;
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
